// extracted by mini-css-extract-plugin
export default {"btn_container":"Delete_btn_container__qMOis","delete":"Delete_delete__hfj6+","cancle":"Delete_cancle__yHG2I","button1":"Delete_button1__4CjC3"};